import styled from 'styled-components'
import { Style } from '../../styles'

const ConversationMessages = styled.div`
	width: 100%;
	padding: 0 ${Style.spacing.x2};
`

export default ConversationMessages 